import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import StockNavbar from "./StockNavbar";

const EditStockRegisterType = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState({ RegisterName: "", Is_Active: true });
  const params = useParams();
  const navigate = useNavigate();

  document.title = "Edit Stock Register Type";

  useEffect(() => {
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Stock/GetStockRegisterTypeByID",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: parseInt(params.id, 10),
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setRecord(response.data.StockRegisterType || {});
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [params.id, AccessKey, UserID, MemberType]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Stock/UpdateStockRegisterType",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: parseInt(params.id, 10),
        RegisterName: event.target.RegisterName.value,
        Is_Active: event.target.Is_Active.checked,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/StockManagement/ManageStockRegisterTypes");
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });

    setValidated(true);
  };

  return (
    <>
      <StockNavbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/StockManagement/StocksDashboard">Stocks</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Register Type
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Stock Register Type</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/StockManagement/ManageStockRegisterTypes"
                  className="button button-white button-icon"
                >
                  Manage Register Types
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body p-md-4">
              {loading && !record.ID ? (
                <Spinner animation="border" role="status" />
              ) : (
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <div className="row align-items-end gy-3">
                    <div className="col-md-6">
                      <label>Register Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="RegisterName"
                        defaultValue={record.RegisterName}
                        required
                        maxLength={300}
                      />
                    </div>
                    <div className="col-md-3">
                      <div className="form-check mt-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="Is_Active"
                          id="Is_Active"
                          defaultChecked={record.Is_Active}
                        />
                        <label className="form-check-label" htmlFor="Is_Active">
                          Active
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 text-end">
                      {loading ? (
                        <Spinner animation="border" role="status" />
                      ) : (
                        <button type="submit" className="button button-primary w-100">
                          UPDATE
                        </button>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditStockRegisterType;
